import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <section
          className="footer-newsletter"
          aria-labelledby="footer-brand-title"
        >
          <p className="footer-newsletter__wordmark">{siteConfig.logo.text}</p>
          <h2 id="footer-brand-title" className="footer-newsletter__title">
            Everyday pieces, considered well.
          </h2>
          <p className="footer-newsletter__description">
            Questions about an order or product? Email{" "}
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            .
          </p>
          <p className="footer-newsletter__description">
            {siteConfig.contact.address}
          </p>
          <div
            className="footer-payments"
            aria-label="Supported payment methods"
          >
            <span>VISA</span>
            <span>Mastercard</span>
            <span>AMEX</span>
            <span>UnionPay</span>
          </div>
        </section>
        <div className="site-footer__navigation">
          {siteConfig.footerNavigation.map((group) => (
            <nav
              className="footer-navigation"
              aria-label={`${group.title} footer navigation`}
              key={group.title}
            >
              <h2 className="footer-navigation__title">{group.title}</h2>
              <ul className="footer-navigation__list">
                {group.links.map((item) => (
                  <li className="footer-navigation__item" key={item.href}>
                    <Link className="footer-navigation__link" to={item.href}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="site-footer__meta">
          <div className="footer-social" aria-label="Contact">
            <a
              className="footer-social__link"
              href={`mailto:${siteConfig.contact.email}`}
            >
              {siteConfig.contact.email}
            </a>
          </div>
          <div className="site-footer__legal">
            <p className="site-footer__copyright">
              © {new Date().getFullYear()} {siteConfig.company.legalName}
            </p>
            <p className="site-footer__location">
              {siteConfig.contact.address} · {siteConfig.contact.email} ·{" "}
              {siteConfig.currency}
            </p>
          </div>
          <button
            className="site-footer__back-to-top"
            type="button"
            onClick={scrollToTop}
          >
            Back to top <span aria-hidden="true">↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
